import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import OtterAvatar from './OtterAvatar';
import FeedbackModal from './FeedbackModal';

/**
 * Floating button — bottom-right of every authenticated page.
 * Opens the FeedbackModal where the user can describe a bug / improvement.
 */
const FeedbackButton = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Auto-detect a friendly page label from the URL
  const computePageLabel = () => {
    const p = location.pathname || '/';
    if (p === '/' || p === '/dashboard') return 'Tableau de bord';
    if (p.startsWith('/clients/')) return 'Détail enseigne';
    if (p === '/clients') return 'Liste des enseignes';
    if (p === '/contacts') return 'Contacts';
    if (p === '/base-maag') return 'Base MAAG';
    if (p === '/fournisseurs') return 'Fournisseurs';
    if (p === '/archives') return 'Archives';
    if (p.startsWith('/projets/') && p.includes('/marge')) return 'Marge projet';
    if (p.startsWith('/projets/nouveau')) return 'Nouveau projet';
    if (p.startsWith('/projets/') && p.includes('/devis/nouveau')) return 'Nouveau devis (projet)';
    if (p.startsWith('/projets/')) return 'Détail projet';
    if (p === '/projets') return 'Liste des projets';
    if (p === '/devis') return 'Liste des devis';
    if (p.startsWith('/devis/nouveau')) return 'Nouveau devis';
    if (p.startsWith('/devis/')) return 'Édition devis';
    if (p === '/admin/users') return 'Admin · Utilisateurs';
    if (p === '/admin/diagnostics') return 'Admin · Diagnostics';
    if (p === '/admin/modifications') return 'Admin · Modifications app';
    if (p.startsWith('/planning/')) return 'Planning';
    return p;
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="feedback-fab"
        title="Une remarque, une idée, un bug ? Cliquez sur la loutre !"
        className="fixed bottom-20 right-5 z-40 group flex items-center gap-2 bg-white shadow-xl border border-amber-200 rounded-full pl-1 pr-4 py-1 hover:shadow-2xl hover:border-amber-400 hover:scale-105 active:scale-95 transition-all"
        style={{ boxShadow: '0 8px 24px -4px rgba(217, 119, 6, 0.25)' }}
      >
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-100 to-amber-200 flex items-center justify-center overflow-hidden">
          <OtterAvatar size={42} />
        </div>
        <span className="hidden sm:inline text-sm font-semibold text-amber-900 group-hover:text-amber-700">
          Une idée ?
        </span>
      </button>

      {open && (
        <FeedbackModal
          onClose={() => setOpen(false)}
          pageUrl={location.pathname}
          pageLabel={computePageLabel()}
        />
      )}
    </>
  );
};

export default FeedbackButton;
